import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { translateFn } from '../../../../utils/translator.helper';
import { GzSetADIntegratorWebComponent } from './component';
import { ConsoleRequest, DataProviderEntity, DataProviderType } from '../../../../utils/request';
import { AD_CHANGE_EVENT, SetADResponse } from './component/interfaces';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { TreeDetails } from '../../../networkTree/types';

export class SetADPopUp extends NetworkBasePopUp<GzSetADIntegratorWebComponent> {
  protected extraDialogConfigs: Partial<GzDialog> = {
    isWindow: false,
  };
  protected title = translateFn('Set as AD Integrator?');
  protected customEventNameAfterConfirm = AD_CHANGE_EVENT;
  private adFolderEventDetails: TreeDetails;

  protected customSetup(): void {
    this.popUpContent = new GzSetADIntegratorWebComponent();
    this.popUpFooterButtons = [
      {
        id: 'confirmButton',
        label: translateFn('Confirm'),
      },
      {
        id: 'closeButton',
        label: translateFn('Cancel'),
      },
    ];

    const target = this.data.targets ? this.data.targets[0] : null;
    const isPartner = Application.Main.getUser().role.rights.manageCompanies;

    if (!target) {
      throw new Error('AD target is not defined');
    }

    const endpointName = target.name;
    const companyName = target?.company?.name;
    this.popUpContent.adActionProps = {
      endpointName,
      companyName,
      isPartner,
    };
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    if (!this.data.targets) {
      throw new Error('Targets are not defined');
    }

    const protectedEntityId = this.data.targets[0]._id;
    let response;
    try {
      response = await ConsoleRequest.createRequest<SetADResponse>({
        dataProviderType: DataProviderType.ENDPOINTS,
        dataProviderEntity: DataProviderEntity.MODEL,
        endpoint: 'UnifiedEndpoints',
        method: 'markAsADSyncer',
        payload: {
          protectedEntityId: protectedEntityId,
        },
      });
    } catch (e) {
      console.error(e);
      this.showErrorToastNotification(e?.err?.message || translateFn('Failed to set endpoint as AD Integrator.'));
      return;
    }

    this.showCustomToast(translateFn('Endpoint successfully set as AD Integrator.'));

    if (!response.newAdFolder) {
      return;
    }

    const companyId = this.data.targets[0]?.company?.id;
    if (!companyId) {
      return;
    }
    const treeNodeResponse = await ConsoleRequest.createRequest<{ data: ProtectedEntity[] }>({
      dataProviderType: DataProviderType.CORE,
      dataProviderEntity: DataProviderEntity.MODEL,
      endpoint: 'ProtectedEntitiesEPS',
      method: 'getProtectedEntityById',
      payload: {
        protectedEntityId: companyId,
        selectedFields: ['type', 'path', 'parentId'],
        page: 1,
        limit: 0,
        sort: null,
        dir: null,
        filter: [],
      },
    });

    const protectedEntity = treeNodeResponse.data[0];

    if (!protectedEntity) {
      console.error('No target for tree re-render after AD integration');
      return;
    }

    this.adFolderEventDetails = {
      targetId: protectedEntity._id,
      path: protectedEntity.path,
      type: protectedEntity.type,
      parentId: protectedEntity.parentId,
    };
  }

  protected getCustomEventDetail(): any {
    return {
      refreshTree: this.adFolderEventDetails,
    };
  }
}
